import Button from "@/components/bricks/button/Button";
import { useState } from "react";
import CodetagIcon from "../icons/CodetagIcon";
import { useQuery } from "@tanstack/react-query";
import { get } from "../../api/util";
import {
  DropdownMenuRoot,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
} from "./DropdownMenu";

const KodeTagDropdown = ({
  onKodeTagSelect,
  emailType,
}: {
  onKodeTagSelect: (kodetag: string) => void;
  emailType: IEmailTypes;
}) => {
  const [open] = useState(false);
  const { data, isLoading } = useQuery<string[]>({
    queryKey: [`flettefelter-${emailType}`],
    queryFn: function () {
      return get({
        query: `email/send/${emailType}/flettefelter`,
      });
    },
  });

  return (
    <DropdownMenuRoot>
      <DropdownMenuTrigger>
        <Button
          transparent
          color="secondary"
          className={`btn--icon rounded${open ? " text-dark" : ""}`}
          aria-label="Indsæt flettefelt"
        >
          <CodetagIcon />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <>
          <DropdownMenuLabel>Flettefelter</DropdownMenuLabel>
          {data && !isLoading
            ? data.map((tag) => (
                <DropdownMenuItem
                  onClick={() => onKodeTagSelect(tag)}
                  key={tag}
                >
                  {tag}
                </DropdownMenuItem>
              ))
            : null}
        </>
      </DropdownMenuContent>
    </DropdownMenuRoot>
  );
};

export default KodeTagDropdown;
